import { ChatPostRequest, ChatPutRequest } from "../types/chatTypes";

export async function chatPostApi(options: ChatPostRequest): Promise<ReadableStream<Uint8Array>> {
    const response = await fetch("/chat", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include", // equivalent to withCredentials: true
        body: JSON.stringify(options)
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    if (!response.body) {
        throw new Error("No response body");
    }

    return response.body;
}

export async function chatPutApi(options: ChatPutRequest): Promise<ReadableStream<Uint8Array>> {
    const response = await fetch("/chat", {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include", // equivalent to withCredentials: true
        body: JSON.stringify(options)
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    if (!response.body) {
        throw new Error("No response body");
    }

    return response.body;
}
